import React, { Suspense } from 'react';
import featureFlags from './featureFlags';

import './App.scss';

const PageComponent = React.lazy(() => {
  let pageId = null;
  if (window.parkchirp && window.parkchirp.page) {
    pageId = window.parkchirp.page;
  }
  else {
    pageId = new URLSearchParams(window.location.search).get('page');
  }

  switch (pageId) {
    case 'parkchirp_billing_profiles':
      return import('./Components/Pages/BillingProfile/BillingProfileListPage');
    case 'parkchirp_billing_profile':
      return import('./Components/Pages/BillingProfile/BillingProfileDetailPage');
    case 'parkchirp_rates':
      return import('./Components/Pages/Rate/RateListPage');
    case 'parkchirp_general_settings':
      return import('./Components/Pages/GeneralSettings/FacilityGeneralSettings');
    case 'parkchirp_rate':
      return import('./Components/Pages/Rate/RateDetailPage');
    case 'parkchirp_subscriptions':
      return import('./Components/Pages/Subscription/SubscriptionListPage');
    case 'parkchirp_subscription':
      return import('./Components/Pages/Subscription/SubscriptionDetailPage');
    case 'parkchirp_parkers':
      return import('./Components/Pages/Parker/ParkerListPage');
    case 'parkchirp_parker':
      return import('./Components/Pages/Parker/ParkerDetailPage');
    case 'parkchirp_billing':
      return import('./Components/Pages/Billing/BillingDashboardPage');
    case 'parkchirp_invoices':
      return import('./Components/Pages/Invoice/InvoiceListPage');
    case 'parkchirp_invoice':
      return import('./Components/Pages/Invoice/InvoiceDetailPage');
    case 'parkchirp_carryover_invoice':
      return import('./Components/Pages/Invoice/CarryoverInvoicePage');
    case 'parkchirp_reports':
      return import('./Components/Pages/Reports/ReportDashboardPage');
    case 'individual-parker':
      return import('./Components/Purchase');
    case 'parkchirp_credits':
      return featureFlags.CREDITS ? import('./Components/Pages/Credit/CreditListPage') : import('./Components/Pages/UnknownPage');
    case 'parkchirp_credit':
      return featureFlags.CREDITS ? import('./Components/Pages/Credit/CreditDetailPage') : import('./Components/Pages/UnknownPage');
    default:
      return import('./Components/Pages/UnknownPage');
  }
});

class App extends React.Component {
  render() {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <PageComponent />
      </Suspense>
    );
  }
}

export default App;
